import { cloneElement, isValidElement } from 'react';

import type { IconProps } from '../Icon';
import type { ButtonProps } from './Button.types';

type GetThemedIconProps = {
    color?: IconProps['color'];
    size: IconProps['size'];
    className?: string;
};

export const getThemedIcon = (props: GetThemedIconProps) => {
    return (el: ButtonProps['icon']) => {
        if (!el) return el;

        if (isValidElement<IconProps>(el)) {
            return cloneElement(el, {
                ...props,
                ...el.props,
                className: [props.className, el.props?.className].filter(Boolean).join(' '),
            });
        }
        return null;
    };
};
